export default {"src":"/_next/static/media/checkbox.eb6bebb0.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};